<template>
  <div class="grid-view" style="height: 100%">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @click-more="value=>isAdvancedQuery=value"
      @advSearchItemCallBack="toAdvancedQuery"
      @simSearchItemCallBack="toSimpleQuery"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
      <template slot="other">
        <slot name="other" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :grid-params.sync="gridParams"
        style="width: 100%; height: 100%"
        @gridReady="onGridReady"
      />
    </div>
    <div id="footer-wrapper-tab-billpayment" class="pagination-wrapper">
      <div :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-show="selectedDataList.length > 0">
          {{ $t('Clearing.Selected') + selectedDataList.length + ':' }}
        </span>
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :type="totalType"
          :arap-group="true"
          :amount-to-currency="localCurrency"
          :data-field="totalDataField"
          :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
          :arap-order="'ar,ap'"
          :source="'bankSlip'"
          :ar-field="arField"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="total"
        :page-count="pageCount"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQueryByPage"
      />
    </div>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import {
  BANK_SLIP_RELEASE_STATES_ALL,
  BANK_SLIP_STATES_ALL,
  CASH_TRANSFER_STATES,
  getClearingBankSlipByCode
} from '@/class/cargo/model/parameters/ClearingConstants'
import * as writeoffApi from '@/api/act/writeoff'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { getBankAccountList } from '@/api/bankAccount'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'BankSlipQuery',
  components: {
    searchItem,
    chargeCurrencyTotalGroup,
    ChargeCountGroup
  },
  props: {
    pageMode: { type: Number, required: true, default: 0 }, // 0 水单认领、1 认领信息-费用、2 认领信息-账单
    identify: { type: String, required: true, default: 'fmBankSlip' }, // ID
    viewSource: { type: String, required: true, default: 'fmBankSlip' }, // 引用页面
    configModule: { type: String, default: '1300' }, // 高级查询条件
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    rateField: { type: String, default: 'converRate' }, // 汇率字段
    arField: { type: String, default: 'ap' }, // 收付字段
    isAr: { type: Number, default: -1 }, // 收付
    oversea: { type: Number, default: -1 }, // 国内外
    isPrepay: { type: Number, default: -1 }, // 是否预付
    isClaim: { type: Boolean, default: false }, // 是否认领
    checkRole: { type: Boolean, default: true }, // 校验权限
    isRollback: { type: Boolean, default: false }, // 是否撤销
    isRegister: { type: Boolean, default: false }, // 是否登记
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    gridConfigModule: { type: String, default: '1300001' } // 列表设置
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: true, // 是否为高级查询
      documentManage: new DocumentManage(),
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      simQueryPlaceholder: this.$t('Clearing.QuickRetrievalWaterBillNumber'),
      searchItemCode: this.$t('Clearing.WaterBillClaims'),
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      selectedData: null,
      // 银行账户列表（列表渲染使用）
      bankAccounts: null,
      selectedDataList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 行点击事件
        onRowClicked: this.onRowClicked,
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        }
      },
      showVoucherDate: false,
      showInvoiceDetail: false,
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceiptNo'), field: 'actualAmountNo', width: 200, colId: 'actualAmountNo'
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentCompany'), field: 'paymentCompany', width: 100, colId: 'paymentCompany' },
        { headerName: this.$t('CargoMsg.Cargo_OurBank'), field: 'ourBank', width: 100, colId: 'ourBank' },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'voucherNo', width: 100, colId: 'voucherNo' },
        { headerName: this.$t('CargoMsg.Cargo_BankReceiptNo'), field: 'bankWaterNo', width: 100, colId: 'bankWaterNo' },
        { headerName: this.$t('CargoMsg.Cargo_ClaimedBy'), field: 'bankSlipReceiveBy', width: 100, colId: 'bankSlipReceiveBy',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'payReceiveDate', width: 100, colId: 'payReceiveDate',
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentType'), field: 'ar', width: 100, colId: 'ar',
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_Dues')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PublishStatus'), field: 'releaseState', width: 100, colId: 'releaseState',
          valueFormatter: params => {
            const releaseState = getClearingBankSlipByCode(params.value, BANK_SLIP_RELEASE_STATES_ALL)
            if (releaseState) {
              return releaseState.chineseName
            } else {
              return this.$t('CargoMsg.Cargo_UnKnownStatus')
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BankReceiptStatus'), field: 'cashTransferState', width: 100, colId: 'cashTransferState',
          valueFormatter: params => {
            const releaseState = getClearingBankSlipByCode(params.value, CASH_TRANSFER_STATES)
            if (releaseState) {
              return this.isZh ? releaseState.chineseName : releaseState.englishName
            } else {
              return this.$t('Clearing.NotUsed')
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ClaimStatusOfAR'), field: 'bankSlipState', width: 100, colId: 'bankSlipState',
          valueFormatter: params => {
            const releaseState = getClearingBankSlipByCode(params.value, BANK_SLIP_STATES_ALL)
            if (releaseState) {
              return releaseState.chineseName
            } else {
              return this.$t('CargoMsg.Cargo_UnKnownStatus')
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ClaimStatusOfAdvanceReceipt'), field: 'preBankSlipState', width: 100, colId: 'preBankSlipState',
          valueFormatter: params => {
            const releaseState = getClearingBankSlipByCode(params.value, BANK_SLIP_STATES_ALL)
            if (releaseState) {
              return releaseState.chineseName
            } else {
              return this.$t('CargoMsg.Cargo_UnKnownStatus')
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'type', width: 100, colId: 'type',
          valueFormatter: params => {
            return ColumnUtils.amountReceiveTypeLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 100, colId: 'currency' },
        {
          headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 100, colId: 'amount',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TheAmountOfWrittenOff'),
          field: 'verfiedAmount',
          width: 100,
          colId: 'verfiedAmount',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RemainingAmount'), field: 'remainAmount', width: 100, colId: 'remainAmount',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.data.amount - params.data.verfiedAmount, 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AdvanceReceiptOrNot'), field: 'prePayment', width: 100, colId: 'prePayment',
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', width: 100, colId: 'createdBy',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', width: 100, colId: 'remark' },
        { headerName: this.$t('Payment.purpose'), field: 'purpose', width: 100, colId: 'purpose', hide: true },
        { headerName: this.$t('Payment.postscript'), field: 'postscript', width: 100, colId: 'postscript', hide: true },
        { headerName: this.$t('CargoMsg.Cargo_ReturnActualAmountNo'), field: 'returnActualAmountNo', width: 120, minWidth: 120, colId: 'returnActualAmountNo', hide: true },
        { headerName: this.$t('CargoMsg.Cargo_ReturnAmount'), field: 'returnAmount', width: 100, minWidth: 100, colId: 'returnAmount', hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReturnApplyAmount'), field: 'returnApplyAmount', width: 100, minWidth: 100, colId: 'returnApplyAmount', hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReturnApplyState'), field: 'returnApplyState', width: 100, minWidth: 100, colId: 'returnApplyState', hide: true,
          valueFormatter: params => {
            return ColumnUtils.returnApplyStateLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_VoucherStatus'), field: 'voucherState', width: 100, minWidth: 100, colId: 'voucherState', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.voucherStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'verificationDate', width: 100, colId: 'verificationDate', hide: true,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BankSlipDateCreated'), field: 'dateCreated', width: 100, colId: 'dateCreated', hide: true,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    // 加载银行账户列表（列表渲染使用）
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
      return res.data
    })
    this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    refreshPageHandler() {
      this.doAdvancedQuery()
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    scrollCallback() {},
    toSimpleQuery(keyword) {
      if (keyword) {
        this.filter.pageNum = 1
        this.filterJson.actualAmountNo = keyword.trim()
        this.filterJson.conditions = []
        this.doAdvancedQuery()
      }
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.actualAmountNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    async doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      if (this.filterJson.actualAmountNo) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.ACTUALAMOUNTNO', this.filterJson.actualAmountNo, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      this.filterJson.requires = []
      if (this.isAr !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.AR', this.isAr === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.oversea !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.isPrepay !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', this.isPrepay === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.BANK_SLIP', true, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      if (this.isRegister && !AdvancedSearchOption.hasField('actualAmount.RELEASE_STATE', this.filterJson.conditions)) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.RELEASE_STATE', [0, 1], AdvancedSearchConsts.OPERATOR_IN.code))
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.BANK_SLIP_STATE', 0))
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.PRE_BANK_SLIP_STATE', 0))
      }
      if (this.isClaim && !AdvancedSearchOption.hasField('actualAmount.RELEASE_STATE', this.filterJson.conditions)) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.RELEASE_STATE', 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.isRollback && !AdvancedSearchOption.hasField('actualAmount.BANK_SLIP_STATE', this.filterJson.conditions) && !AdvancedSearchOption.hasField('actualAmount.PRE_BANK_SLIP_STATE', this.filterJson.conditions)) {
        this.filterJson.requires.push('actualAmount.BANK_SLIP_STATE')
        this.filterJson.requires.push('actualAmount.PRE_BANK_SLIP_STATE')
      }

      if (AdvancedSearchOption.hasField(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, this.filterJson.conditions)) {
        const special = AdvancedSearchOption.removeOption(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, this.filterJson.conditions)
        let operator = special.operator
        if (operator === AdvancedSearchConsts.OPERATOR_IS_NULL.code) {
          operator = AdvancedSearchConsts.OPERATOR_NOT_IN.code
        } else if (operator === AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code) {
          operator = AdvancedSearchConsts.OPERATOR_IN.code
        }
        this.filterJson.conditions.push(new AdvancedSearchOption(null, special.fieldName, null, operator))
      }
      if (AdvancedSearchOption.hasField('actualAmount.OURBANK', this.filterJson.conditions)) {
        this.filterJson.requires.push('writeQuery')
        const offsetStateOption = AdvancedSearchOption.getOption('actualAmount.OURBANK', this.filterJson.conditions)
        // CARGO-15680，新版的销账页签银行查询条件有问题
        const bankAccount = this.bankAccounts.find(p => (p.accountNo + '' + p.currency) === String(offsetStateOption.value))
        if (bankAccount) {
          AdvancedSearchOption.removeOption('actualAmount.OURBANK', this.filterJson.conditions)
          offsetStateOption.value = bankAccount.currency + '||' + bankAccount.accountNo
          this.filterJson.conditions.push(offsetStateOption)
        }
      }
      if (this.showVoucherDate) {
        this.filterJson.requires.push('voucherDate')
      }
      if (this.showInvoiceDetail) {
        this.filterJson.requires.push('invoice')
      }
      if (this.viewSource === 'bankSlipRollBack') {
        this.filterJson.requires.push('voucherPage')
      }
      this.preQueryActualAmount(this.filterJson.conditions)
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      await writeoffApi.queryActualAmountPageable(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.selectedDataList = []
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
      selectedStatus.revert()
    },
    preQueryActualAmount(conditions) {
      // 只能查看自己认领的水单，admin查看所有
      if (!this.$store.getters.isAdmin && this.checkRole) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.VERIFICATIONBY', this.$store.getters.userId, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.selectedData = f
            }
          }
        })
      }
    },
    initCustomSearchItems() {
      const defaultSearchFields = []
      // 我方银行
      if (this.bankAccounts) {
        const dataProvider = []
        for (const bankAccount of this.bankAccounts) {
          const chineseName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
          const englishName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankEnglishName
          // CARGO-15701，销账查询页签，我方银行的查询条件:币种+账号
          dataProvider.push({ code: (bankAccount.accountNo + '' + bankAccount.currency), chineseName: chineseName, englishName: englishName })
        }
        console.log('ourSideBank ', dataProvider)
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.defaultValue = ''
        searchField.itemLabel = 'WriteOff.ourSideBank'
        searchField.itemName = 'actualAmount.OURBANK'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.lock = false
        searchField.dataProvider = dataProvider
        searchField.action = 2
        searchField.defaultSelected = 0
        searchField.selected = 0
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
      return this.customSearchItems
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
